export default class DefaultAnalyticsConfig {
  //page views
  static titleReplicaReader = "ReplicaReader";
  static titleNextgenReader = "NextgenReader";
  static titleReplicaReaderInBackground = "BackgroundReplicaReader";
  static titleArticleLightBox = "ArticleLightBox";
  static titleGallery = "ImageGallery";
  static titleHome = "Home";
  static titlePayWall = "PayWall";
  static titleSupplementsOverview = "SupplementsOverview";

  //events

  //er
  static erTag = "335c0dc60397467ab96682f73d5f6311";

  static erUserReferenceType = "subscriptionUserReference";

  // Google analytics
  static useGA = true;
  static useGTM = false;

  //xiti
  static xitiPageViewsOnlyTagging = true;

  // tealium
  static tealium = {
    utagUrl: undefined,
    utagSyncUrl: undefined,
    cpmtUrl: undefined,
    utagDomain: undefined,
    utagPath: undefined,
    utagEnv: undefined,
  };

  // Adobe Analytics
  static adobe = {
    url: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/common/analytics/defaultAnalyticsConfig.js